'use strict';
var userAgent = require('../internals/engine-user-agent');

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-ios.js
// module id = 511
// module chunks = 0